import { Container, Stack, Typography } from "@mui/material";
import React from "react";
import HelpCard from "../../components/cards/HelpCard";
import { t } from "i18next";

let helpway = [
  {
    title: "workerFaqs",
    link: "/faqs",
    type: "worker",
  },
  {
    title: "companyFaqs",
    link: "/faqs",
    type: "company",
  },
  {
    title: "supplierFaqs",
    link: "/faqs",
    type: "company",
  },
  {
    title: "userFaqs",
    link: "/faqs",
    type: "user",
  },
  {
    title: "contactSupport",
    link: "/contact",
    type: "support",
  },
];
// let helpway = [
//   {
//     title: "Register as a Client",
//     link: "/help-center/customer-support",
//   },
//   {
//     title: "Register as a Worker",
//     link: "/help-center/customer-support",
//   },
//   {
//     title: "Register as a Supplier",
//     link: "/help-center/customer-support",
//   },
//   {
//     title: "Register as a School",
//     link: "/help-center/customer-support",
//   },
// ];

const Help = () => {
  return (
    <Container sx={{ maxWidth: "600px !important" }}>
      <Typography
        variant="heading_pr"
        component={"h1"}
        textAlign={"center"}
        color={"text.white"}
        lineHeight={"normal"}
      >
        {t('helpHeading')}!
      </Typography>
      <Stack spacing={2} mt={3}>
        {helpway.map((val, index) => {
          return <HelpCard data={val} index={index} />;
        })}
      </Stack>
    </Container>
  );
};

export default Help;
